import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {finalize, from, lastValueFrom, Observable, timer} from 'rxjs';
import {Injectable, Injector} from '@angular/core';
import {PermissionService} from '../services';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {LoadingDialogComponent} from "../components/shared";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    // Counter to track ongoing API calls
    private _ongoingApiCallsCounter = 0;
    // Reference to the loading dialog
    private _loadingDialogRef: MatDialogRef<LoadingDialogComponent> | undefined;

    constructor(private matDialog: MatDialog,
                private injector: Injector,
                private permissionService: PermissionService) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Convert promise to observable using 'from' operator
        return from(this.handle(req, next));
    }

    async handle(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
        // Clone the request to add the Authorization header
        let overwrittenRequest = req.clone({
            setHeaders: {
                Authorization: 'Bearer ' + await this.permissionService.getAccessToken()
            }
        });

        // Open the loading dialog
        this.openLoadingDialog();

        // Handle the request and close the loading dialog after a delay
        return lastValueFrom(next.handle(overwrittenRequest).pipe(
            finalize(() => {
                timer(500).subscribe(() => this.closeLoadingDialog());
            })
        ));
    }

    private closeLoadingDialog() {
        this._ongoingApiCallsCounter--; // Decrement the counter
        if (this._ongoingApiCallsCounter == 0) {
            // Close the loading dialog if there are no ongoing API calls
            if (this._loadingDialogRef !== undefined) {
                this._loadingDialogRef.close();
            }
        }
    }

    private openLoadingDialog() {
        this._ongoingApiCallsCounter++; // Increment the counter
        if (this._ongoingApiCallsCounter == 1) {
            // Open the loading dialog if this is the first API call
            this._loadingDialogRef = this.matDialog.open(LoadingDialogComponent, { disableClose: true });
        }
    }
}
